import React, { useEffect, useState } from "react";
import Emoji from "./Emoji";


export default function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iOS Safari
    const userAgent = window.navigator.userAgent.toLowerCase();
    const iOSDevice = /iphone|ipad|ipod/.test(userAgent);
    const inStandalone = window.matchMedia("(display-mode: standalone)").matches;
    setIsIOS(iOSDevice && !inStandalone);

    // Listen for the install prompt (Android/desktop Chrome)
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("Install prompt outcome:", outcome);
    setDeferredPrompt(null);
    setShowButton(false);
  };

  // Hide if already installed
  useEffect(() => {
    const mq = window.matchMedia("(display-mode: standalone)");
    const handler = () => setShowButton(false);
    if (mq.addEventListener) {
      mq.addEventListener("change", handler);
    } else if (mq.addListener) {
      mq.addListener(handler); // Fallback for older browsers
    }
    if (mq.matches) setShowButton(false);
    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener("change", handler);
      } else if (mq.removeListener) {
        mq.removeListener(handler);
      }
    };
  }, []);

  if (isIOS) {
    return (
      <div className="fixed bottom-3 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-4 py-2 rounded-2xl shadow-lg z-50">
        <Emoji symbol="📱" label="mobile phone" className="mr-1" />
Tap <strong>Share → Add to Home Screen</strong> to install.
      </div>
    );
  }

  if (!showButton) return null;

  return (
    <button
      onClick={handleInstallClick}
      className="fixed bottom-4 right-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full shadow-lg transition z-50"
    >
      <Emoji symbol="📲" label="install app" className="mr-1" />
Install App
    </button>
  );
}
